import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { backendApiSlice, useGetProfilesQuery } from 'services/backend';
import { logoutAction } from 'store/actions';
import { RootState } from 'store/index';

export const useEnsureProfiles = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const {
    data: profiles,
    isLoading,
    isFetching,
  } = useGetProfilesQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (!isAuthenticated) return;
    if (isLoading || isFetching) return;
    if (profiles === undefined) return;

    if (profiles && profiles.length === 0) {
      dispatch(logoutAction());
      dispatch(backendApiSlice.util.resetApiState());
    }
  }, [profiles, isLoading, isFetching, isAuthenticated]);
};
